// Generic UI/runtime configuration: pagination defaults, timeouts, settings keys,
// and viewport-derived layout helpers.

export const PER_PAGE_DEFAULT = 15;
export const INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 60 minutes

export const Settings = {
  maxNumberForMessages: "maxNumberForMessages",
  automatedClientMessages: "automatedClientMessages",
  notificationSettings: "notificationSettings",
};

const PORTRAIT_QUERY = "(orientation: portrait)";

// Reads orientation fresh each call, unlike a module-level matchMedia() constant.
export function isPortraitLayout(): boolean {
  return window.matchMedia(PORTRAIT_QUERY).matches;
}

export function getTableLayoutOnMobile(isMobile: boolean): "simple" | "standard" {
  return isMobile && isPortraitLayout() ? "simple" : "standard";
}
